import React, { useState, useEffect } from 'react';
import * as BosWebGuiServices from "data/BosWebServices/BosWebGuiServices";
import { getTranslation as translate } from "logic/LocaleManager";

// DevExtreme components
import { SelectBox } from 'devextreme-react';
import DropDownButton from 'devextreme-react/drop-down-button';

//Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appStateActions from "redux/actions/appStateActions";

function LanguageSelector(props) {
  const { currentDataSegment, currentDataSegmentSessionId, hint, currentUILanguageCode, currentDataViewLanguageCode, disabled } = props;

  const [uiLanguages, setUILanguages] = useState([]);
  const [dataViewLanguages, setDataViewLanguages] = useState([]);
  const [error, setError] = useState(false);

  let currentCombinedLanguage = 1;
  let combinedLanguages = [{
    text: (currentDataViewLanguageCode ? currentDataViewLanguageCode.toUpperCase() : "??") + " - " + (currentUILanguageCode ? currentUILanguageCode.toUpperCase() : "??"),
    id: 1,
    icon: "globe",
  }];

  useEffect(() => {
    async function fetchData() {
      try {
        console.log("GetAvailableLanguages for session " + currentDataSegmentSessionId)
        let result = await BosWebGuiServices.fetchGetAvailableLanguages(currentDataSegment.authToken, currentDataSegmentSessionId, currentDataSegment.id);
        console.log("GetAvailableLanguages for DataSegmentId " + currentDataSegment.id + " result:", result);
        setUILanguages(result.availableUILanguages.map(l => { return { text: l.toUpperCase(), id: l }; }));
        setDataViewLanguages(result.availableDataViewLanguages.map(l => { return { text: l.toUpperCase(), id: l }; }));
        setError(false);
      } catch (error) {
        console.error("GetAvailableLanguages for DataSegmentId " + currentDataSegment.id + " error:", error);
        setUILanguages([]);
        setDataViewLanguages([]);
        setError(true);
      }
    }

    if (currentDataSegment && currentDataSegmentSessionId) fetchData();
    else {
      setUILanguages([]);
      setDataViewLanguages([]);
    }

  }, [currentDataSegment, currentDataSegmentSessionId]);

  const setLanguagePreferences = async (uiLanguageISOCode, dataViewLanguageISOCode) => {
    try {
      console.log("SetLanguagePreferences for session " + currentDataSegmentSessionId)
      let result = await BosWebGuiServices.fetchSetLanguagePreferences(currentDataSegment.authToken, currentDataSegmentSessionId, currentDataSegment.id, uiLanguageISOCode, dataViewLanguageISOCode);
      console.log("SetLanguagePreferences for DataSegmentId " + currentDataSegment.id + " result:", result);
    } catch (error) {
      console.log("SetLanguagePreferences for DataSegmentId " + currentDataSegment.id + " error:", error);
      setUILanguages([]);
      setDataViewLanguages([]);
    }
  }

  const onUILanguageChanged = (languageISOCode) => {
    setLanguagePreferences(languageISOCode, currentDataViewLanguageCode)
      .then(props.appStateActions.setUILanguage(languageISOCode));
  }

  const onDataViewLanguageChanged = (languageISOCode) => {
    setLanguagePreferences(currentUILanguageCode, languageISOCode)
      .then(props.appStateActions.setDataViewLanguage(languageISOCode));
  }

  const doubleSelectionContainer = {
    display: "grid",
    margin: "16px 0px",
    gap: "8px",
    justifyContent: "center",
  }

  const disabledTextContainer = {
    margin: "0px 16px",
  }

  const renderDisabledSelection = () => {
    return (
      <div style={doubleSelectionContainer}>
        <div style={disabledTextContainer}>
          {translate("languageSelector.disabledText", "You cannot change language settings if you have any open tasks")}
        </div>
      </div>
    );
  }

  const renderDoubleSelection = () => {
    return (
      <div style={doubleSelectionContainer}>
        <div>{translate("languageSelector.dataViewLanguage", "DataView Lang.") + ":"}</div>
        <div>
          <SelectBox
            width="8em"
            height="2em"
            value={currentDataViewLanguageCode}
            displayExpr="text"
            valueExpr="id"
            dataSource={dataViewLanguages}
            onValueChanged={args => onDataViewLanguageChanged(args.value)}
          />
        </div>
        <div>{translate("languageSelector.uiLanguage", "UI Language") + ":"}</div>
        <div>
          <SelectBox
            width="8em"
            height="2em"
            value={currentUILanguageCode}
            displayExpr="text"
            valueExpr="id"
            dataSource={uiLanguages}
            onValueChanged={args => onUILanguageChanged(args.value)}
          />
        </div>
      </div>
    );
  }

  return (
    <DropDownButton
      width="8em"
      hint={hint}
      disabled={error}
      useSelectMode={true}
      selectedItemKey={currentCombinedLanguage}
      keyExpr="id"
      displayExpr="text"
      stylingMode="text"
      dropDownOptions={{ width: "12em" }}
      dataSource={combinedLanguages}
      dropDownContentRender={() => disabled ? renderDisabledSelection() : renderDoubleSelection()}
    />
  );
}

function mapStateToProps(state, ownProps) {
  return {
    currentUILanguageCode: state.appState.uiLanguageIsoCode,
    currentDataViewLanguageCode: state.appState.dataViewLanguageIsoCode
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appStateActions: bindActionCreators(appStateActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector);